import { getWordCount } from '@Common/handlers/helper';
import QuillEditor, { QuillEditorIDS } from '@Common/handlers/quillEditor';
import { openToastr } from '@Common/handlers/services';
import { getReduxStore } from 'src/_common/redux/store';
import { changeInputTextAction, setGrammarErrorAction } from '../actions/userActions';
import { FIX_ALL_GRAMMAR_ERRORS_EVENT_NAME, UnderlinedClassnames } from '../utils';
import grammarbotTrack from './track';

const dispatch = (action: any) => getReduxStore()?.dispatch(action);
const gcState = () => getReduxStore()?.getState()?.grmr;

export const fixAllGrammarErrors = (triggeredBy = 'fixAllButton') => {
  const FIX_ALL_GRAMMAR_ERRORS_EVENT = new CustomEvent(FIX_ALL_GRAMMAR_ERRORS_EVENT_NAME, {
    detail: {},
  });

  if (!gcState()?.controls.isGrammarCheckRunning) {
    const errorNodes = Array.from(
      document.querySelectorAll(
        `.${UnderlinedClassnames.ERROR_UNDERLINE_CLASS_NAME}, .${UnderlinedClassnames.PARAPHRASE_UNDERLINE_CLASS_NAME}`
      )
    ) as HTMLElement[];
    if (errorNodes.length) {
      grammarbotTrack.clickedCorrectAllGrammarErrorsButton(errorNodes.length, triggeredBy);
      errorNodes.forEach((errorNode) => {
        errorNode.dispatchEvent(FIX_ALL_GRAMMAR_ERRORS_EVENT);
      });
      const inputHTML = QuillEditor.getInstance(QuillEditorIDS.GRAMMAR_EDITOR)?.getContent(
        'html'
      ) as string;
      const inputText = QuillEditor.getInstance(QuillEditorIDS.GRAMMAR_EDITOR)?.getContent(
        'text'
      ) as string;
      dispatch(setGrammarErrorAction(0));
      dispatch(
        changeInputTextAction(
          inputHTML,
          inputText,
          getWordCount(inputText),
          inputText?.trim()?.length
        )
      );
      openToastr('Fixed all grammar errors.');
    }
  }
};
